import React from 'react';
import { RouteEnum } from '../constantes/RouteEnum';
import Welcome from '../pages/welcome/Welcome';
import Otp from '../pages/authentication/Otp';
import { LoginUserName } from '../pages/authentication/LoginUserName/LoginUserName';
import { LoginPassword } from '../pages/authentication/LoginPassword/LoginPassword';
import Personal from '../pages/registerFlow/personal/Personal';
import Contact from '../pages/registerFlow/contact/Contact';
import Address from '../pages/registerFlow/address/Address';
import Finish from '../pages/finish/Finish';
import Invitation from '../pages/invitation/Invitation';
import AdditionalInfo from '../pages/registerFlow/additionalInfo/AdditionalInfo';
import SignupValidation from '../pages/validation/signup/SignupValidation';
import SignupValidationCode from '../pages/validation/signup/SignupValidationCode';
import PasswordValidation from '../pages/validation/password/PasswordValidation';
import PasswordValidationCode from '../pages/validation/password/PasswordValidationCode';
import { ValidateOtpResetPassword } from '../pages/authentication/ValidateOtpResetPassword/ValidateOtpResetPassword';
import { CreatePassword } from '../pages/authentication/createPassword/CreatePassword';
import { ResetPassword } from '../pages/authentication/ResetPassword/ResetPassword';
import { OnboardingConfigPassword } from '../pages/registerFlow/onboardingConfigPassword/OnboardingConfigPassword';
import { OtpRequest } from '../pages/authentication/OtpRequest/OtpRequest';
import { OtpValidation } from '../pages/authentication/OtpValidation/OtpValidation';
import LogoutPage from '../pages/authentication/Logout';
import ComplementaryStep from '../pages/registerFlow/complementaryStep/ComplementaryStep';

export const routes = {
  welcome: {
    path: RouteEnum.WELCOME,
    element: <Welcome/>
  },
  LogoutPage: {
    path: RouteEnum.LOGOUT,
    element: <LogoutPage/>
  },
  
  // Auth
  loginUsername: {
    path: RouteEnum.LOGIN_USERNAME,
    element: <LoginUserName/>
  },
  
  loginPassword: {
    path: RouteEnum.LOGIN_PASSWORD,
    element: <LoginPassword/>
  },
  forgotPassword: {
    path: RouteEnum.FORGOT_PASSWORD_OTP_REQUEST,
    element: <OtpRequest/>
  },
  
  resetPassword: {
    path: RouteEnum.RESET_PASSWORD,
    element: <ResetPassword/>
  },
  
  // OTP
  otpRequest: {
    path: RouteEnum.OTP_REQUEST,
    element: <OtpRequest/>
  },
  
  validateOtpResetPassword: {
    path: RouteEnum.VALIDATE_OTP_RESET_PASSWORD,
    element: <ValidateOtpResetPassword/>
  },
  
  otpValidation: {
    path: RouteEnum.OTP_VALIDATION,
    element: <OtpValidation/>
  },
  
  personal: {
    path: RouteEnum.PERSONAL,
    element: <Personal/>
  },
  otp: {
    path: RouteEnum.OTP,
    element: <Otp/>
  },
  register: {
    path: RouteEnum.CREATE_PASSWORD_ONBOARDING,
    element: <OnboardingConfigPassword/>
  },
  contact: {
    path: RouteEnum.CONTACT,
    element: <Contact/>
  },
  address: {
    path: RouteEnum.ADDRESS,
    element: <Address/>
  },
  createPassword: {
    path: RouteEnum.CREATE_PASSWORD,
    element: <CreatePassword/>
  },
  finish: {
    path: RouteEnum.FINISH,
    element: <Finish/>
  },
  signupValidation: {
    path: RouteEnum.SIGNUP_VALIDATION,
    element: <SignupValidation/>
  },
  signupValidationCode: {
    path: RouteEnum.SIGNUP_VALIDATION_CODE,
    element: <SignupValidationCode/>
  },
  passwordValidation: {
    path: RouteEnum.PASSWORD_VALIDATION,
    element: <PasswordValidation/>
  },
  passwordValidationCode: {
    path: RouteEnum.PASSWORD_VALIDATION_CODE,
    element: <PasswordValidationCode/>
  },
  invitation: {
    path: RouteEnum.INVITATION,
    element: <Invitation/>
  },
  info: {
    path: RouteEnum.ADD_INFO,
    element: <AdditionalInfo/>
  },
  complementaryStep: {
    path: RouteEnum.COMPLEMENTARY_STEP,
    element: <ComplementaryStep/>
  }
  
};

export default routes;
